import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { InfoIcon } from '../../../../components/info-icon';

const CustomCell = ({ field, row }) => {
	if (field === 'id') {
		return (
			<div className="custom-cell__id">
				<InfoIcon popupContent={`№ ${row[field]}`} link={row.link} />
			</div>
		);
	}

	if (field === 'tk' && row.tk) {
		return (
			<Link className="custom-cell__link" to={row.link}>
				{row.tk.name}
			</Link>
		);
	}

	return row[field];
};

CustomCell.propTypes = {
	row: PropTypes.object.isRequired,
	field: PropTypes.string.isRequired,
};

export { CustomCell };
